import moment from 'moment';
import Parse from '../Parse';
import Filter from './Filter';

let hasPrevPlanRef = [], hasNextPlanRef = [], getAllNextPlanRef = [];

const transferControllerStations = (userDevice, userPlanDevice, deviceConfig) => {
    
    let result = [];
    const user = Parse.User.current();
    const todayDate = new Date();
    const userPlanDeviceLength = userPlanDevice.length;
    for(var b = 0; b < userPlanDeviceLength; b++){
        var uPD = userPlanDevice[b];
        var prevPlanRef = uPD.get('prevPlanRef');		
        if(prevPlanRef !== undefined){
            hasPrevPlanRef[prevPlanRef.id] = uPD.get('controller') + ',' + moment(uPD.updatedAt).format('DD MMMM YYYY');
        }
        var nextPlanRef = uPD.get('nextPlanRef');		
        if(nextPlanRef !== undefined){
            hasNextPlanRef[uPD.id] = nextPlanRef.id;
        }                                  
        var updatedAtValue = uPD.updatedAt;
        if(uPD.updatedAt === undefined) { 
            updatedAtValue = new Date(); /**j today date**/ 
        }
        getAllNextPlanRef[uPD.id] = uPD.get('controller') + ',' + moment(uPD.updatedAt).format('DD MMMM YYYY');
    }
    const deviceConfigLength = deviceConfig.length;
    for(let i = 0; i < deviceConfigLength; i++) {
        const dvCfg = deviceConfig[i];
        if(!dvCfg.get('controller')) {
            continue; 
        }
        if(dvCfg.get('deletedPlanDevice')) {
            continue; 
        }

        const deviceController = dvCfg.get('controller');
        const deviceOwner = dvCfg.get('owner');
        const deviceName = dvCfg.get('deviceName');

        let planExpiryValueText = "";
        let newPlanList = [], oldPlanList = [], planList = [];
        let planExpiryValue = new Date();
        let planName = null;
        let planStatus = null;
        let planNameText = "";
        let allowDevice = 0;
        let reportEmail = "";
        let planMessages = ""; 
        let planType = 0;
        let planDetails = "";

        if(deviceOwner === user.id) {
            newPlanList = setPlanListNew(userPlanDevice, deviceController);
            if(newPlanList.length !== 0) {
                planList = newPlanList;
                if(hasNextPlanRef[planList[0].id] != undefined){				
                    planExpiryValueText = new Date(planList[0].attributes.planExpiry);						
                    planExpiryValue = new Date(planList[0].attributes.planExpiry);		
                }else{
                    if(hasPrevPlanRef[planList[0].id] != undefined){
                        planExpiryValueText = new Date(planList[0].updatedAt);						
                        planExpiryValue = new Date(planList[0].updatedAt);	
                    }else{	
                        planExpiryValueText = planList[0].attributes.planExpiry;				
                        planExpiryValue = new Date(planList[0].attributes.planExpiry);
                    }
                }			
            } else {
                oldPlanList = setPlanListOld(userDevice);
                planList = oldPlanList;
                if(planList.length != 0){
                    if(hasNextPlanRef[planList[0].id] != undefined){				
                        planExpiryValueText = new Date(planList[0].attributes.planExpiry);						
                        planExpiryValue = new Date(planList[0].attributes.planExpiry);		
                    }else{					
                        if(hasPrevPlanRef[planList[0].id] != undefined){
                            planExpiryValueText = new Date(planList[0].updatedAt);						
                            planExpiryValue = new Date(planList[0].updatedAt);	
                        }else{											
                            if( (planList[0].attributes.hasOwnProperty('expiryDate')) && (planList[0].attributes.expiryDate != "") && (planList[0].attributes.expiryDate != undefined) ){
                                planExpiryValueText = planList[0].attributes.expiryDate;
                                planExpiryValue = new Date(planList[0].attributes.expiryDate);
                            }else{
                                planExpiryValue = new Date(planList[0].createdAt);
                            }
                        }
                    }					
                }
            }
        }
        
        if(typeof planList[0] !== 'undefined') {                   
            planName = planList[0].get('planName');
            planNameText = planName;
            allowDevice = planList[0].get('planDevices');
            reportEmail = planList[0].get('reportEmail');
            planType = planList[0].get('planType');
            planDetails = planList[0].get('option1');

            if(hasNextPlanRef[planList[0].id] !== undefined){			
                planName = planName + '<br><span class="planName_EXPIRED">Transferred</span>';	
                planStatus = "Transferred";
                let setIDValue = hasNextPlanRef[planList[0].id];
				let setMessageDetail = getAllNextPlanRef[setIDValue];
				let getMessageDetail = setMessageDetail.split(",");
                planMessages = 'Your ' + planNameText + 
                    ' Plan on this device has been successfully transferred to <br/>your Control Station ID ' + 
                    getMessageDetail[0] + ' on Date ' +  
                    getMessageDetail[1]
            }else{
                if(hasPrevPlanRef[planList[0].id] !== undefined){
                    planName = planName + '<br><span class="planName_EXPIRED">Transferred</span>';
                    planStatus = "Transferred";
                    let setMessageDetail = hasPrevPlanRef[planList[0].id];
					let getMessageDetail = setMessageDetail.split(",");
                    planMessages = 'Your ' + planNameText + 
                        ' Plan on this device has been successfully transferred to <br/>New Control Station ID ' + 
                        getMessageDetail[0] + ' on Date ' +  
                        getMessageDetail[1]
                }else{
                    if((planExpiryValue !== "") && (planExpiryValue <= todayDate)){			
                        planName = planName + '<br><span class="planName_EXPIRED">EXPIRED</span>'
                        planStatus = "EXPIRED";
                    }
                }
            }		
        }
        
        const temp = {
            deviceConfigId: dvCfg.id,
            deviceModel: dvCfg.get('deviceModel'),
            appVer: dvCfg.get('appVer'),
            menuVer: dvCfg.get('menuVer'),
            usageMode: dvCfg.get("usageMode"),
            clients: dvCfg.get("clients"),
            controller: deviceController,
            owner: deviceOwner,
            name: deviceName,
            plan: planName !== null ? planName : "",
            planText: planNameText,
            planExpiryValue: planExpiryValue,
            planStatus: planStatus,
            comment: planList.length > 0 ? deviceOwner : (
                deviceOwner !== user.id ? user.id : deviceOwner
            ),
            updatedAt: dvCfg.updatedAt,
            createdAt: dvCfg.createdAt,
            allowDevice: allowDevice,
            reportEmail: reportEmail,
            planMessages: planMessages,
            planType: planType,
            planDetails: Filter.isJSON(planDetails) ? JSON.parse(planDetails) : {}
        };
        result.push(temp)
    }
    
    return result;
}

function setPlanListNew(userPlanData, deviceConfigController) {
    var rightValue = [];
    for (var i = 0; i < userPlanData.length; i++) {
        var userPlanController = userPlanData[i].get('controller');
        if(userPlanController === deviceConfigController){
            rightValue.push(userPlanData[i]);		
        }    
    }
    return rightValue;
}

function setPlanListOld(userPlanData){
	var rightValue = [];
	for (var i = 0; i < userPlanData.length; i++) {
        rightValue.push(userPlanData[i]);		
	}
	return rightValue;
}

export default transferControllerStations;